export class BuildingAddressModel {
    id: number;
    label: string;
    postCode: string;
    city: string;
    constructor() { }
}
